import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/relay-system-status",
		component: lazy(() => import("./RelaySystemStatusPage")),
	},
]);
